module.exports = __webpack_public_path__ + "img/logo-mini-dark.5f8508c7.svg";